import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useAuthCheck, useGetQueryStr } from '../hook'
import { theme } from '../styles/theme'
import { Button_Main } from './Button'
import { InputItem, SearchInputItem } from './Form'

const Container = styled.form`
  display: flex;
  align-items: center;
  padding: 20px;
  margin-top: 20px;
  border-radius: 10px;
  border: 1px solid ${theme.colors.green};
  width: 100%;
  gap: 10px;
  flex-wrap: wrap;  /* 자식 요소가 넘치면 다음 줄로 */
`


const SearchForm = ({searchList}:{searchList:DefaultParamKeys[]}) => {
  const { queryParams, changeObjectQuery } = useGetQueryStr()
  const [param, setParam] = useState(defaultParam)
  const { checkAuth } = useAuthCheck()
  const paramChange = (name: string) => (value: string | number) => setParam((prev) => ({ ...prev, [name]: value }))
  const handleReset = () => setParam(defaultParam)
  const handleSearch = (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault(); // 폼의 기본 제출 동작 방지
    changeObjectQuery(param)
  };

  useEffect(()=>{
    queryParams.forEach((value, key) => paramChange(key)(value));
  },[])

  const setSearchList = (key: DefaultParamKeys) => 
        key === "role" ? <SearchInputItem key={key} type={'dropdown'} name={'권한'} kind={'roleSearch'} currentItem={param[key]} setCurrentItem={paramChange(key)} />
      : key === "partName" ? checkAuth('1000') && <SearchInputItem key={key} type={'input'} name={defaultParamLabel[key]} kind={undefined} currentItem={param[key]} setCurrentItem={paramChange(key)} />
      : key === "groupName" ? checkAuth('1100') && <SearchInputItem key={key} type={'input'} name={defaultParamLabel[key]} kind={undefined} currentItem={param[key]} setCurrentItem={paramChange(key)} />
      : <SearchInputItem key={key} type={'input'} name={defaultParamLabel[key]} kind={undefined} currentItem={param[key]} setCurrentItem={paramChange(key)} />

  return (
    <Container onSubmit={handleSearch}>
      {searchList.map((key)=>setSearchList(key))}

      <Button_Main type="submit" >검색</Button_Main>
      <Button_Main $bgColor={theme.colors.blue} onClick={handleReset}>
        검색 초기화
      </Button_Main>
    </Container>
  )
}

export default SearchForm

const defaultParamLabel = {
  partName: '소속',
  groupName: '그룹',
  macAddress: 'MAC',
  loginId: '아이디',
  userName: '이름',
  pageNo:'페이지',
  role:'권한',
  driveNumber: '차량번호'
}

const defaultParam = {
  partName: '',
  groupName: '',
  macAddress:'',
  loginId: '',
  userName: '',
  pageNo:'1',
  role:'',
  driveNumber: ''
}
export type DefaultParam = typeof defaultParam
export type DefaultParamKeys = keyof typeof defaultParam